export default __webpack_public_path__ + "static/media/Hyrmax_hero_md.6ff5971a.jpg";